const customContactNumberStyles = {
  inputLabel: {
    color: "#475569",
    fontSize: "14px",
    flexShrink: 0,
    fontWeight: 600,
    marginLeft: "5px",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      border: "none !important",
      borderRadius: "0.5rem"
    },
    "& .MuiInputBase-input": {
      padding: "10px 8px",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none !important",
    },
  },
} as const;

export default customContactNumberStyles;
